import React, { useState } from "react";
import { TrendingUp } from "lucide-react";
import GestionaleShell from "./GestionaleShell";
import GestCrudTable from "./GestCrudTable";

const FIELDS = [
  { key: "period", label: "Periodo", type: "text", required: true, placeholder: "2026-Q1 / 2026-03" },
  { key: "supplier_name", label: "Fornitore", type: "text" },
  { key: "container_code", label: "Container", type: "text" },
  { key: "fob_eur", label: "FOB (€)", type: "number" },
  { key: "percent", label: "Commissione %", type: "number", step: "0.1", defaultValue: 5 },
  { key: "amount_eur_calc", label: "Importo (€)", type: "text", format: (_, it) => `€ ${(it.amount_eur ?? 0).toLocaleString("it-IT")}` },
  { key: "paid", label: "Pagata", type: "bool", checkboxLabel: "Commissione pagata" },
  { key: "notes", label: "Note", type: "textarea", hideInTable: true },
];

export default function CommissionsPage() {
  const [data, setData] = useState({ total: 0, total_amount_eur: 0, paid_amount_eur: 0 });
  const pending = (data.total_amount_eur || 0) - (data.paid_amount_eur || 0);

  return (
    <GestionaleShell
      icon={TrendingUp}
      code="06"
      title="Commission Engine"
      subtitle="Calcolo automatico commissioni FOB × % per fornitore, container e periodo. Tracking pagamenti."
      kpiBlocks={[
        { value: `€${Math.round((data.total_amount_eur || 0) / 1000)}k`, label: "Commissioni totali" },
        { value: `€${Math.round(pending / 1000)}k`, label: "Da incassare" },
      ]}
    >
      <GestCrudTable
        endpoint="/gestionale/commissions"
        fields={FIELDS}
        itemLabel="commissione"
        emptyHint="Registra le commissioni mensili o trimestrali per fornitore."
        testIdPrefix="commissions"
        onItemsLoaded={(d) => setData(d)}
        rowSummary={(items) => (
          <div className="flex flex-wrap gap-4 text-[11px] uppercase tracking-[0.18em]">
            <span className="text-stone-500">Totale: <b className="text-stone-900">€{(data.total_amount_eur || 0).toLocaleString("it-IT")}</b></span>
            <span className="text-stone-500">Pagato: <b className="text-emerald-700">€{(data.paid_amount_eur || 0).toLocaleString("it-IT")}</b></span>
            <span className="text-stone-500">Pendente: <b className="text-amber-700">€{pending.toLocaleString("it-IT")}</b></span>
          </div>
        )}
      />
    </GestionaleShell>
  );
}
